import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SidenavService {
    private sideNavOpenedStream = new BehaviorSubject(true);

    public get isOpen$() {
        return this.sideNavOpenedStream.asObservable();
    }

    public get isOpen() {
        return this.sideNavOpenedStream.value;
    }

    public toggle(value?: boolean) {
        if (typeof value === 'undefined') {
            this.sideNavOpenedStream.next(!this.isOpen);
        } else {
            this.sideNavOpenedStream.next(value);
        }
    }
}
